export const PROFILE_EDIT = 'PROFILE_EDIT';

export const editProfile = (profile, isValid) => {
    return {
        type: PROFILE_EDIT,
        profile,
        isValid,
        isEdited: true,
    };
};

export const editProfileFinish = () => ({
    type: PROFILE_EDIT,
    profile: null,
    isValid: true,
    isEdited: false,
});